import React from 'react';
import cn from 'classnames';
import PT from 'prop-types';

const Icon = (
	{
		className,
		name,
		pointer = true,
		onClick,
		dataTestId
	}
) => {
	return (
		<span
			className={cn('icon', {
					'icon_pointer': pointer
				},
				name,
				className
			)}
			data-testid={dataTestId}
			onClick={onClick}
		/>
	);
};

Icon.propTypes = {
	className: PT.string,
	name: PT.string,
	pointer: PT.bool,
	onClick: PT.func
};

export default Icon;
